// axios
import axios from 'axios'
import Vue from 'vue'
import store from "../store/index"

const getLabSlug = () =>
  JSON.parse(localStorage.getItem('user_lab_profile') || sessionStorage.getItem('user_lab_profile'))?.laboratory_slug ?? null

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
    // 'Content-Type': 'multipart/form-data'
  }
})

axiosIns.interceptors.request.use(
  config => {
        // Do something before request is sent
    const sessionData = localStorage.getItem('session') || sessionStorage.getItem('session')
    const parsedData = JSON.parse(sessionData)
    const accessToken = parsedData?.access

    // eslint-disable-next-line no-param-reassign
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`
    // console.log(parsedData)

    return config
  },
  error => Promise.reject(error),
)

axiosIns.interceptors.response.use(response => {
  return response;
}, error => {
  if (error?.response?.data?.code === "token_not_valid") {
    sessionStorage.removeItem('session')
    localStorage.removeItem('session')
    localStorage.removeItem('user_lab_profile')
    sessionStorage.removeItem('user_lab_profile')
    localStorage.removeItem('lab_settings')
    sessionStorage.removeItem('lab_settings')

    window.location.replace('login')
  }
  return Promise.reject(error);
});

//logIn
axiosIns.login = form => {
  return axiosIns.post(`account/login`, form)
    .then(response => response.data)
}

//reset forgotten password
axiosIns.resetPassword = form => axiosIns.post(`account/password/reset`, form, {timeout: 7000})
  .then(response => response)

//validate token from password recovery
axiosIns.validateResetPassToken = form => axiosIns.post(`account/password/validate`, form)
  .then(response => response)

axiosIns.changeUserPassword = form => axiosIns.post(`account/password/confirm`, form)
  .then(response => response)

//logged-UserData
axiosIns.getUserDataForProfile = () => axiosIns.get(`api/get-user-info`)
  .then(response => response.data)

// Update Profile
axiosIns.updateUserDataForProfile = form => axiosIns.put(`app/get_user_info`, form) /* CORREGIR */
  .then(response => response.data)

axiosIns.changeUserPasswordProfile = form => axiosIns.patch(`account/password/change`, form)
  .then(response => response.data)

//create User
axiosIns.createUser = form => axiosIns.post(`account/register`, form)
  .then(response => response.data)

//update User
axiosIns.updateUser = (id, form) =>
  axiosIns.patch(`api/${getLabSlug()}/users/${id}/`, form)
    .then(res => res.data);

//get Users
axiosIns.getUsersList = (data) => {
  let url =
    data.page
      ? `api/${getLabSlug()}/users/?page=${data.page}&page_size=${data.page_size}`
      : `api/${getLabSlug()}/users/?paginated=false`

  url += data.search?.length? `&search=${data.search}` : ''
  url += data.summary ? `&summary=${data.summary}` : ''
  url += data.only_users ? `&only_users=${data.only_users}` : ''
  url += data.role >=0  ? `&role=${data.role}` : ''

  return axiosIns.get(url)
    .then(response => response.data)
}

axiosIns.getUsersSummary = (summary) => axiosIns.get(`api/${getLabSlug()}/users/?summary=${summary}`)
  .then(response => response.data)

//get 1 User
axiosIns.getUser = ( id) => axiosIns.get(`api/${getLabSlug()}/users/${id}/`)
  .then(response => response)

// deleteUserByLab
axiosIns.deleteUser = (userId) => {
  return axiosIns.delete(`api/${getLabSlug()}/users/${userId}/`,{
    timeout: 25000
  })
    .then(response => response)
}


//get User By Laboratory
axiosIns.getUsersByLaboratory = (data) => {
  let url =
    data.page
      ? `api/${getLabSlug()}/users/?page=${data.page}&page_size=${data.page_size}`
      : `api/${getLabSlug()}/users/?paginated=false`

  url += data.search?.length? `&search=${data.search}` : ''
  url += data.summary ? `&summary=${data.summary}` : ''
  url += data.only_users ? `&only_users=${data.only_users}` : ''
  url += data.role >=0  ? `&role=${data.role}` : ''

  return axiosIns.get(url)
    .then(response => response.data)
}

// Obtener un usuario específico por ID y laboratorio
axiosIns.getUserById = (userId) => {
  return axiosIns.get(`/api/${getLabSlug()}/users/${userId}/`)
    .then(response => response.data)
}

 /* VETERINARY EPS */
axiosIns.createVeterinary = form => axiosIns.post(`api/${getLabSlug()}/veterinary-clinics/`, form)
  .then(response => response.data)

  //get only id,name of users with specific role
axiosIns.getAsociatedUsers = (summary, role) => axiosIns.get(`api/${getLabSlug()}/users/?summary=${summary}&role=${role}`)
  .then(response => response.data)

axiosIns.getVeterinaryList = ( data) => {
  let url = `api/${getLabSlug()}/veterinary-clinics/?page=${data.page}&page_size=${data.page_size}`
  url += data.search?.length ? `&search=${data.search}` : ''
  url += data.summary ? `&summary=${data.summary}` : ''

  return axiosIns.get(url)
    .then(response => response.data)
}

// Obtener veterinaria específica con slug incluido (ejemplo si aplica)
axiosIns.getVeterinary = ( id) => {
  let url = `api/${getLabSlug()}/veterinary-clinics/${id}/`
  return axiosIns.get(url).then(response => response)
}

// Actualizar veterinaria con slug
axiosIns.updateVeterinary = ( id, form) => {
  let url = `api/${getLabSlug()}/veterinary-clinics/${id}/`
  return axiosIns.put(url, form).then(response => response)
}

// Crear veterinaria con slug (agregar slug si el endpoint lo requiere)
axiosIns.createVeterinary = ( form) => {
  let url = `api/${getLabSlug()}/veterinary-clinics/`
  return axiosIns.post(url, form).then(response => response)
}

// Eliminar veterinaria con slug
axiosIns.deleteVeterinary = ( id) => {
  let url = `api/${getLabSlug()}/veterinary-clinics/${id}/`
  return axiosIns.delete(url).then(response => response)
}

 /* TUTORS EPS */
axiosIns.createTutor = ( form) => axiosIns.post(`api/${getLabSlug()}/tutors/`, form)

axiosIns.getTutorsList = ( data = {}) => {
  let url = `api/${getLabSlug()}/tutors/?page=${data.page || 1}&page_size=${data.page_size || 10}`
  url += data.search?.length ? `&search=${data.search}` : ''
  url += data.summary ? `&summary=${data.summary}` : ''
  url += data.patient ? `&patient=${data.patient}` : ''

  console.log('Fetching tutors from:', url)

  return axiosIns.get(url).then(response => response.data)
}


//get only id,name of tutors
axiosIns.getTutorsSummary = summary=> axiosIns.get(`api/${getLabSlug()}/tutors/?summary=${summary}`)
.then(response => response.data)

axiosIns.deleteTutor = ( id)  => axiosIns.delete(`api/${getLabSlug()}/tutors/${id}/`)
  .then(response => response)

axiosIns.updateTutor = ( id, form) =>
  axiosIns.patch(`api/${getLabSlug()}/tutors/${id}/`, form)


axiosIns.getTutor = ( id) => axiosIns.get(`api/${getLabSlug()}/tutors/${id}/`)
  .then(response => response)

 /* PATIENTS EPS */
axiosIns.createPatient = ( form) => {
  return axiosIns.post(`api/${getLabSlug()}/patients/`, form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(response => response.data)
}

axiosIns.getPatientsList = ( data) => {
  let url = `api/${getLabSlug()}/patients/?page=${data.page}&page_size=${data.page_size}`
  url += data.search?.length ? `&search=${data.search}` : ''
  url += data.summary ? `&summary=${data.summary}` : ''
  url += data.tutor? `&tutor=${data.tutor}` : ''
  url += data.userdata ? `&userdata=${data.userdata}` : ''

  return axiosIns.get(url)
    .then(response => response.data)
}
   //get only id,name of patients
axiosIns.getPatientsSummary = summary=> axiosIns.get(`api/${getLabSlug()}/patients/?summary=${summary}`)
.then(response => response.data)

axiosIns.deletePatient = ( id) => axiosIns.delete(`api/${getLabSlug()}/patients/${id}/`)
 .then(response => response)

// Editar paciente
axiosIns.updatePatient = ( id, form) => {
  return axiosIns.patch(`api/${getLabSlug()}/patients/${id}/`, form)
    .then(response => response.data)
}

// Obtener paciente individual
axiosIns.getPatient = ( id) => {
  return axiosIns.get(`api/${getLabSlug()}/patients/${id}/`)
    .then(response => response.data)
}

 /*  FILES EPS */
axiosIns.createFiles = (id,form) => axiosIns.post(`api/${getLabSlug()}/patients/${id}/files`, form, {headers: {'Content-Type': 'multipart/form-data'}})
 .then(response => response.data)

axiosIns.getPatientFiles = ( id) => axiosIns.get(`api/${getLabSlug()}/patients/${id}/files`)
 .then(response => response)

axiosIns.deletePatientFiles = ( id, form) => axiosIns.delete(`api/${getLabSlug()}/patients/${id}/files`, {data: form})
 .then(response => response)


 /*  DETERMINATIONS EPS */

//Get List
 axiosIns.getDeterminationsList = (data) => {
  let url =
    data.page
      ? `api/${getLabSlug()}/determinations/?page=${data.page}&page_size=${data.page_size}`
      : `api/${getLabSlug()}/determinations/?paginated=false`

  url += data.search?.length ? `&search=${data.search}` : ''
  url += data.summary ? `&summary=${data.summary}` : ''
  url += data.simulator ? `&simulator=true` : ''
  url += data.special_category >=0 ? `&special_category=${data.special_category}` : ''

  return axiosIns.get(url)
    .then(response => response.data)
}

 axiosIns.editDeterminationsList = ( id, data) => axiosIns.patch(`api/${getLabSlug()}/determinations/${id}/`, data)
 .then(response => response.data)

 /*  REPORTS EPS */

axiosIns.getReports = data => {
  let query = '?'

  if (data?.page && data?.page_size) query +=
    query.length >1?
      `&page=${data.page}&page_size=${data.page_size}` : `page=${data.page}&page_size=${data.page_size}`

  if (data?.summary) query +=
    query.length > 1?
     `&summary=${data.summary}` : `summary=${data.summary}`

  if (data?.search) query +=
  query.length > 1?
    `&search=${data.search}` : `search=${data.search}`

  if (data?.status >= 0) query +=
  query.length > 1?
    `&status=${data.status}` : `status=${data.status}`

  return axiosIns.get(`api/${getLabSlug()}/reports/${query.length > 1? query : ''}`)
    .then(response => response.data)
}

axiosIns.getReport = ( id) => axiosIns.get(`api/${getLabSlug()}/reports/${id}/`)
  .then(response => response.data)

axiosIns.updateReport = ( id, form) => axiosIns.patch(`api/${getLabSlug()}/reports/${id}/`, form)
  .then(response => response)

axiosIns.sendDeterminationPDF = (id, form) => axiosIns.post(`api/${getLabSlug()}/reports/${id}/add-det-pdf`, form, {headers: {'Content-Type': 'multipart/form-data'}})
  .then(response => response)

axiosIns.uploadDeterminationImages = (form) => {
  return axiosIns.post(`api/${getLabSlug()}/reports-images/`, form, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(response => response.data);
};

axiosIns.deleteImageByUrl = (imageUrl) => {
  return axiosIns.delete(`api/${getLabSlug()}/reports-images/delete_by_url/`, {
    data: {
      image_url: imageUrl
    }
  }).then(response => response);
};

axiosIns.updateImageDescription = (imageId, description) => {
  return axiosIns.patch(`api/${getLabSlug()}/reports-images/${imageId}/update_description/`, description)
};

axiosIns.getFilesVisibility = ( id) => axiosIns.get(`api/${getLabSlug()}/reports/${id}/file_status`)
  .then(response => response.data)

axiosIns.toggleFilesVisibility = (id, form) => axiosIns.post(`api/${getLabSlug()}/reports/${id}/enabled_files`, form)
  .then(response => response)

axiosIns.sendGeneralAnnexes = (id, form) => axiosIns.post(`api/${getLabSlug()}/reports/${id}/general-annexes`, form, {headers: {'Content-Type': 'multipart/form-data'}})
  .then(response => response)

//report id
axiosIns.deleteAnnexesFile = (id, form) => axiosIns.delete(`api/${getLabSlug()}/reports/${id}/files`, {data: form})
  .then(response => response)

axiosIns.showReportNotification = (id) => axiosIns.get(`api/${getLabSlug()}/reports/${id}/notifications`)
  .then(response => response)

axiosIns.finishReport = (id) => axiosIns.get(`api/${getLabSlug()}/reports/${id}/finish`)
  .then(response => response)

axiosIns.createReportPreview = (id) => axiosIns.get(`api/${getLabSlug()}/reports/${id}/report_preview`)
  .then(response => response)

axiosIns.checkReportPayment = id => axiosIns.get(`api/${getLabSlug()}/requests/${id}/check-payments`)
  .then(response => response)

//check timeout, this request take more time
axiosIns.sendReport = (id, form) => axiosIns.post(`api/${getLabSlug()}/reports/${id}/export`, form, {timeout: 10000})
  .then(response => response)


 /*  REQUESTS EPS */
axiosIns.createRequest = form => axiosIns.post(`api/${getLabSlug()}/requests/`, form)
 .then(response => response.data)

axiosIns.createRequestSkuCheck = ( form) => axiosIns.post(`api/${getLabSlug()}/requests/create-sku-ckeck`, form)
 .then(response => response)

axiosIns.getRequestList = (data) => {
  // let url = `api/requests/?page=${data.page}&page_size=${data.page_size}`

  let url =
    data.page
      ? `api/${getLabSlug()}/requests/?page=${data.page}&page_size=${data.page_size}`
      : `api/${getLabSlug()}/requests/?paginated=false`

  url += data.search?.length ? `&search=${data.search}` : ''
  url += data.summary ? `&summary=${data.summary}` : ''
  url += data.status >= 0 ? `&status=${data.status}` : ''
  url += data.since?.length ? `&since=${data.since}` : ''
  url += data.to?.length ? `&to=${data.to}` : ''
  url += data.sampling_mode >= 0 ? `&sampling_mode=${data.sampling_mode}` : ''

  return axiosIns.get(url)
    .then(response => response.data)
}

axiosIns.getRequest = ( id) => axiosIns.get(`api/${getLabSlug()}/requests/${id}/`)
  .then(response => response)

axiosIns.updateRequest = ( id, form) => axiosIns.patch(`api/${getLabSlug()}/requests/${id}/`, form)
  .then(response => response)

axiosIns.deleteRequest = ( id) => axiosIns.delete(`api/${getLabSlug()}/requests/${id}/`)
  .then(response => response)



// BEGIN: Invoices EPs
/*  REPORTS EPS */

axiosIns.getInvoices = data => {
  let query = '?'

  if (data?.page && data?.page_size) query +=
    query.length >1?
      `&page=${data.page}&page_size=${data.page_size}` : `page=${data.page}&page_size=${data.page_size}`

  if (data?.summary) query +=
    query.length > 1?
      '&summary=true&paginated=false' : 'summary=true&paginated=false'

  if (data?.search) query +=
    query.length > 1?
      `&search=${data.search}` : `search=${data.search}`

  if (data?.status) query +=
    query.length > 1?
      `&status=${data.status}` : `search=${data.status}`

  if (data?.userdata) query +=
    query.length > 1?
      `&userdata=${data.userdata}` : `search=${data.userdata}`


  return axiosIns.get(`api/${getLabSlug()}/invoices/${query.length > 1? query : ''}`)
    .then(response => response.data)
}

axiosIns.createInvoice = form => {
  return axiosIns.post(`api/${getLabSlug()}/invoices/`, form)
    .then(response => response.data)
}

//id is id from items
axiosIns.updateInvoiceItems = (form, id) => {
  return axiosIns.patch(`api/${getLabSlug()}/invoices/${id}/items/`, form)
    .then(response => response.data)
}

axiosIns.getOneInvoice = ( id) => {

  return axiosIns.get(`api/${getLabSlug()}/invoices/${id}/`)
    .then(response => response.data)
}

axiosIns.deleteInvoice = ( id) => {

  return axiosIns.delete(`api/${getLabSlug()}/invoices/${id}/`)
    .then(response => response.data)
}

// axiosIns.createReceipt = id => {
//   return axiosIns.post(`api/payments/${id}/proof`)
//     .then(response => response.data)
// }

axiosIns.shareReceipt = id => {
  return axiosIns.post(`api/${getLabSlug()}/payments/${id}/export`)
    .then(response => response.data)
}

axiosIns.sharePdfElement = (id, form, type) => axiosIns.post(
    `api/${getLabSlug()}/${type === 'invoice'? 'invoices' : 'payments' }/${id}/export`,
    form,
    { timeout: 10000 }
  ).then(response => response)
// END: Invoices EPs


// BEGIN: Payment EPs
axiosIns.getPayments = data => {
  let query = '?'

  if (data?.page && data?.page_size) query +=
    query.length >1?
      `&page=${data.page}&page_size=${data.page_size}` : `page=${data.page}&page_size=${data.page_size}`

  if (data?.summary) query +=
    query.length > 1?
      '&summary=true&paginated=false' : 'summary=true&paginated=false'

  if (data?.search) query +=
    query.length > 1?
      `&search=${data.search}` : `search=${data.search}`

  if (data?.userdata) query +=
    query.length > 1?
      `&userdata=${data.userdata}` : `search=${data.userdata}`


  return axiosIns.get(`api/${getLabSlug()}/payments/${query.length > 1? query : ''}`)
    .then(response => response.data)
}

axiosIns.createPayment = ( form) => {

  return axiosIns.post(`api/${getLabSlug()}/payments/`, form)
    .then(response => response.data)
}

axiosIns.getPaymentFiles = id => axiosIns.get(`api/${getLabSlug()}/payments/${id}/files`)
 .then(response => response)

axiosIns.hiddePayment = id => axiosIns.post(`api/${getLabSlug()}/hide-payment/${id}`)
 .then(response => response)

// END: Payment EPs

//CURRENT ACCOUNT EPS
axiosIns.getCurrentAccount = (id, data )=> {
  let url = `api/${getLabSlug()}/invoices/user-payments?userdata=${id}&page=${data.page}&page_size=${data.page_size}`

  url += data.status >= 0 && data.status != null ? `&status=${data.status}` : ''

  return axiosIns.get(url)
    .then(response => response.data)
}

// DAILY PAYMENTS EPs
axiosIns.getDailyPayments = data => {
  let query = '?'

  if (data?.date_since) query +=
    query.length > 1?
      `&since=${data.date_since}` : `since=${data.date_since}`

  if (data?.date_to) query +=
    query.length > 1?
      `&to=${data.date_to}` : `to=${data.date_to}`

  if (data?.payment_method !== -1) query +=
    query.length > 1?
      `&payment_method=${data.payment_method}` : `search=${data.payment_method}`

  if (data?.page && data?.page_size) query +=
    query.length >1?
      `&page=${data.page}&page_size=${data.page_size}` : `page=${data.page}&page_size=${data.page_size}`

  return axiosIns.get(`api/${getLabSlug()}/daily-payments${query.length > 1? query : ''}`, {timeout: 10000})
    .then(response => response.data)
}

// LAB CUSTOMIZATION EPs

axiosIns.getLabCustomization = () => axiosIns.get(`api/${getLabSlug()}/customization/`)
  .then(response => response)

axiosIns.createLabCustomization = form => axiosIns.post(`api/${getLabSlug()}/customization/`, form, {headers: { 'Content-Type': 'multipart/form-data' }})
  .then(response => response)

axiosIns.updateLabCustomization = form => axiosIns.patch(`api/${getLabSlug()}/customization/`, form)
  .then(response => response)

axiosIns.getEmailCustomization = () => axiosIns.get(`api/${getLabSlug()}/email-config/`)
  .then(response => response)

axiosIns.createEmailCustomization = form => axiosIns.post(`api/${getLabSlug()}/email-config/`, form)
  .then(response => response)

axiosIns.updateEmailCustomization = form => axiosIns.patch(`api/${getLabSlug()}/email-config/`, form)
  .then(response => response)

axiosIns.sendTestEmail = form => axiosIns.post(`api/${getLabSlug()}/email-config/test-email/`, form)
  .then(response => response)

// New endpoint to clear a signature
axiosIns.clearSignature = signature_number => axiosIns.delete(`api/${getLabSlug()}/customization/clear-signature/${signature_number}/`)
  .then(response => response)

// PAYMENT DETAILS EPs

axiosIns.getPaymentDetails = () => axiosIns.get(`api/${getLabSlug()}/payment_details/`)
  .then(response => response.data)

axiosIns.updatePaymentDetails = form => axiosIns.patch(`api/${getLabSlug()}/payment_details/`, form)
  .then(response => response)

Vue.prototype.$api = axiosIns

export default axiosIns
